export default data => ({
  chart: {
    zoomType: "xy",
    width: data.chartWidth,
    height: data.chartHeight,
    alignTicks: true
    // margin: "8px",
    // spacing: 0
  },
  title: {
    text: data.chartTitle
  },
  subtitle: {
    text: data.chartSubTitle && data.chartSubTitle
  },
  navigator: {
    enabled: false
  },
  scrollbar: {
    enabled: false //it is set to true on xaxis only below, as when it renders then, it is real-time scroll rather than on mouse out
  },
  series: data.series,
  plotOptions: {
    column: {
      grouping: false
    }
  },
  tooltip: {
    //shared: true,
    split: data.isTooltipSplit
  },
  xAxis: {
    title: {
      text: data.xAxisLabel
    },
    scrollbar: {
      enabled: true //it is set to true on xaxis only here, as when it renders then, it is real-time scroll rather than on mouse out
    }
  },
  legend: {
    enabled: data.showLegend,
    symbolWidth: 32,
    // symbolHeight: 16,
    // squareSymbol: false,
    // symbolRadius: 0,
    // layout: 'vertical',
    // align: 'left',
    // x: 120,
    verticalAlign: "top",
    //y: 40,

    // floating: true,
    //backgroundColor: "#ccc"
    ...data.legend
  },
  rangeSelector: {
    enabled: false
  },
  yAxis: data.yAxes
  // yAxis: [
  //   {
  //     id: "right-center-zero",
  //     title: {
  //       text:
  //         data.yAxes["right-center-zero"] &&
  //         data.yAxes["right-center-zero"].series.join(", ")
  //     },
  //
  //     visible: data.yAxes["right-center-zero"] !== undefined,
  //     min:
  //       data.yAxes["right-center-zero"] &&
  //       data.yAxes["right-center-zero"].range &&
  //       data.yAxes["right-center-zero"].range.lowerRange,
  //     max:
  //       data.yAxes["right-center-zero"] &&
  //       data.yAxes["right-center-zero"].range &&
  //       data.yAxes["right-center-zero"].range.upperRange,
  //     opposite:
  //       data.yAxes["right-center-zero"] &&
  //       data.yAxes["right-center-zero"].opposite
  //   },
  //   {
  //     id: "left-absolute",
  //     title: {
  //       text:
  //         data.yAxes["left-absolute"] &&
  //         data.yAxes["left-absolute"].series.join(", ")
  //     },
  //     opposite:
  //       data.yAxes["left-absolute"] && data.yAxes["left-absolute"].opposite,
  //     visible: data.yAxes["left-absolute"] !== undefined,
  //     min: data.yAxes["left-absolute"] && data.yAxes["left-absolute"].min
  //   },
  //   {
  //     id: "AXIS_1",
  //     title: {
  //       text: data.yAxes["AXIS_1"] && data.yAxes["AXIS_1"].series.join(", ")
  //     },
  //     opposite: false,
  //     visible: data.yAxes["AXIS_1"] !== undefined,
  //     min: data.yAxes["AXIS_1"] && data.yAxes["AXIS_1"].min
  //   },
  //   {
  //     id: "AXIS_2",
  //     title: {
  //       text: data.yAxes["AXIS_2"] && data.yAxes["AXIS_2"].series.join(", ")
  //     },
  //     opposite: false,
  //     visible: data.yAxes["AXIS_2"] !== undefined,
  //     min:
  //       data.yAxes["AXIS_2"] &&
  //       data.yAxes["AXIS_2"].range &&
  //       data.yAxes["AXIS_2"].range.lowerRange,
  //     max:
  //       data.yAxes["AXIS_2"] &&
  //       data.yAxes["AXIS_2"].range &&
  //       data.yAxes["AXIS_2"].range.upperRange
  //   },
  //   {
  //     id: "AXIS_3",
  //     title: {
  //       text: data.yAxes["AXIS_3"] && data.yAxes["AXIS_3"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_3"] !== undefined,
  //     min:
  //       data.yAxes["AXIS_3"] &&
  //       data.yAxes["AXIS_3"].range &&
  //       data.yAxes["AXIS_3"].range.lowerRange,
  //     max:
  //       data.yAxes["AXIS_3"] &&
  //       data.yAxes["AXIS_3"].range &&
  //       data.yAxes["AXIS_3"].range.upperRange
  //   },
  //   {
  //     id: "AXIS_4",
  //     title: {
  //       text: data.yAxes["AXIS_4"] && data.yAxes["AXIS_4"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_4"] !== undefined,
  //     min:
  //       data.yAxes["AXIS_4"] &&
  //       data.yAxes["AXIS_4"].range &&
  //       data.yAxes["AXIS_4"].range.lowerRange,
  //     max:
  //       data.yAxes["AXIS_4"] &&
  //       data.yAxes["AXIS_4"].range &&
  //       data.yAxes["AXIS_4"].range.upperRange
  //   },
  //   {
  //     id: "AXIS_5",
  //     title: {
  //       text: data.yAxes["AXIS_5"] && data.yAxes["AXIS_5"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_5"] !== undefined,
  //     min: 0
  //   },
  //   {
  //     id: "AXIS_6",
  //     title: {
  //       text: data.yAxes["AXIS_6"] && data.yAxes["AXIS_6"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_6"] !== undefined,
  //     min: 0
  //   },
  //   {
  //     id: "AXIS_7",
  //     title: {
  //       text: data.yAxes["AXIS_7"] && data.yAxes["AXIS_7"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_7"] !== undefined,
  //     min: 0
  //   },
  //   {
  //     id: "AXIS_8",
  //     title: {
  //       text: data.yAxes["AXIS_8"] && data.yAxes["AXIS_8"].series.join(", ")
  //     },
  //     opposite: true,
  //     visible: data.yAxes["AXIS_8"] !== undefined,
  //     min: 0
  //   }
  // ]
});



// WEBPACK FOOTER //
// ./src/views/core/core_report_chart/core_chart/chart.config.js